import { render, staticRenderFns } from "./TimelineGestao.vue?vue&type=template&id=5328ccf6&scoped=true&"
import script from "./TimelineGestao.vue?vue&type=script&lang=js&"
export * from "./TimelineGestao.vue?vue&type=script&lang=js&"
import style0 from "./TimelineGestao.vue?vue&type=style&index=0&id=5328ccf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328ccf6",
  null
  
)

export default component.exports